/** Types */
export const ADD_AVATAR = "ADD_AVATAR";
export const DELETE_AVATAR = "DELETE_AVATAR";
